import {
  Component,
  inject,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PreferencesService } from '@services/preferences.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'MealCheck-Portage';
  showInformationsBand: boolean = false;

  private translate = inject(TranslateService);
  private router = inject(Router);
  private prefs = inject(PreferencesService);

  constructor() {
    this.translate.addLangs(['fr', 'en']);
    this.translate.setFallbackLang('en');
  }

  ngOnInit(): void {
    this.initLanguage();
    this.subscribePreferences();
    this.subscribeRouterEvents();
  }

  private initLanguage(): void {
    // Appliquer la langue préférée au démarrage
    const currentLang = this.prefs.getPreferencesSnapshot().language;
    if (currentLang) {
      this.translate.use(currentLang);
    }
  }

  private subscribePreferences(): void {
    // Écouter les changements de préférences (notamment la langue)
    this.prefs.prefs$.subscribe(p => {
      if (p && p.language) {
        this.translate.use(p.language);
      }

      this.applyTextPreferences(p);
    });
  }

  private subscribeRouterEvents(): void {
    this.router.events.subscribe(() => {
      this.updateInformationsBandVisibillity();
    });
  }

  private updateInformationsBandVisibillity() {
    const currentRoute = this.router.url;
    this.showInformationsBand = currentRoute.includes('/dashboard');
  }

  private applyTextPreferences(prefs: any) {
    if (!prefs) return;
    const root = document.documentElement;

    // Classe pour texte en gras
    if (prefs.boldText) {
      root.classList.add('pref-bold-text');
    } else {
      root.classList.remove('pref-bold-text');
    }

    // Classe pour texte en majuscule
    if (prefs.uppercaseText) {
      root.classList.add('pref-uppercase-text');
    } else {
      root.classList.remove('pref-uppercase-text');
    }

    // Classe pour mode dyslexie
    if (prefs.dyslexicMode) {
      root.classList.add('pref-dyslexic-mode');
    } else {
      root.classList.remove('pref-dyslexic-mode');
    }
  }
}
